enum WebserviceToolboxFields {
	ENABLED = "toolbox_enabled",
	INSTANCES = "toolbox_instances",
	QUEUE = "toolbox_queue",
	LATENCY = "toolbox_latency",
}

export default WebserviceToolboxFields;